<div class="place-content-center max-w-[1680px] mx-auto px-5" *transloco="let t">
    <h1 class="text-secondary text-[32px] font-semibold">{{t('title')}}</h1>
    <pre class="pt-10 text-black font-medium text-[16px]" style="white-space: break-spaces;">{{t('desc1')}}</pre>
    <pre class="pt-10 text-black font-medium text-[16px]" style="white-space: break-spaces;">{{t('desc2')}}</pre>
    <pre class="pt-10 text-black font-medium text-[16px]" style="white-space: break-spaces;">{{t('desc3')}}</pre>
    <pre class="pt-10 text-black font-medium text-[16px]" style="white-space: break-spaces;">{{t('desc4')}}</pre>
</div>